

<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">
      {{ "Component Details - Flagged" | translate | async }}<!--  {{ title }} -->
    </span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
  </div>
  <div class="ttmodal__body">
    <div>
      <mat-form-field>
        <input matInput placeholder="{{ 'Description' | translate | async }}"[disabled]="true"  [(ngModel)]="FlaggedInfo.Description">
      </mat-form-field>
    </div>
    
    <div>
      <mat-form-field>
        <input matInput placeholder="{{ 'Brand' | translate | async }}" [disabled]="true" [(ngModel)]="FlaggedInfo.Brand">
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <input matInput placeholder="{{ 'Part #' | translate | async }}" [disabled]="true" [(ngModel)]="FlaggedInfo.PartNo">
      </mat-form-field>
    </div>
    <div *ngIf="componentTypeId==230">
      <mat-form-field>
        <input matInput placeholder="{{ 'Job #' | translate | async }}" [disabled]="true" [(ngModel)]="FlaggedInfo.JobNo">
      </mat-form-field>
    </div>
    <div *ngIf="componentTypeId==230">
      <mat-form-field>
        <input matInput placeholder="{{ 'Master Link' | translate | async }}" [disabled]="true"  [(ngModel)]="FlaggedInfo.Mlink">
      </mat-form-field>
    </div>
    <div *ngIf="componentTypeId==233">
      <mat-form-field>
        <input matInput placeholder="{{ 'Asset #' | translate | async }}"  [disabled]="true"  [(ngModel)]="FlaggedInfo.AssetNo">
      </mat-form-field>
    </div>
    <div *ngIf="componentTypeId==232">
      <mat-form-field>
        <input matInput placeholder="{{ 'Cleaner Holes' | translate | async }}" [disabled]="true"  [(ngModel)]="FlaggedInfo.ShoeCleanerHole">
      </mat-form-field>
    </div>
     <div *ngIf="componentTypeId==232">
      <mat-form-field>
        <input matInput placeholder="{{ 'Shoe Size' | translate | async }}" [disabled]="true" [(ngModel)]="FlaggedInfo.ShoeSize">
      </mat-form-field>
    </div> 

    <div *ngIf="componentTypeId==231">
      <mat-form-field>
        <input matInput placeholder="{{ 'Bush Turned' | translate | async }}" [disabled]="true"  [(ngModel)]="FlaggedInfo.BushTurned">
      </mat-form-field>
    </div>
    
  </div>
  <div>
    <mat-form-field>
      <input matInput placeholder="{{ 'Comment' | translate | async }}" [disabled]="true" [(ngModel)]="FlaggedInfo.Comment">
    </mat-form-field>
  </div>

  <div class="button-container">
    <button mat-raised-button (click)="onNoClick()">{{'Cancel' | translate | async}}</button>
    <button mat-raised-button color="warn" (click)="UpdateComponentFlagged()">{{'Save' | translate | async}}</button>
  </div>
  
</div>
